<template>
    <div class="border border-1 p-2">
        <h5>
            Payment Calculator
        </h5>
        <div class="row">
            <div class="col-sm-6 mb-2">
                <div>Down Payment:
                <span>{{ downPaymentCurrency }}</span>
                </div>
                <div class="elementor-field-type-text elementor-field-group">
                    <input type="range" class="form-range" 
                           v-model="downPayment"
                           min="0" step="100" :max="price">
                </div>
            </div>
            <div class="col-sm-6 mb-2">
                <div># of months:
                    <span>{{months}}</span>
                </div>
                <div class="elementor-field-type-text elementor-field-group">
                    <input type="range" class="form-range" 
                           v-model="months"
                           min="1" max="120">
                </div>
            </div>
            <div class="col-sm-6 mb-2">
                <div class="d-inline d-sm-block">Today's Rate (APR):</div>
                {{ (rate * 100).toFixed(2) }}%
            </div>
            <div class="col-sm-6 mb-2">
                <div>Monthly Payment *</div>
                <h5>
                    {{ monthlyPayment }}
                </h5>
            </div>
        </div>
        <p class="small">
            * Your actual payment may vary. <a v-show="!disclaimer" href="" @click.prevent="disclaimer = true">See disclaimer.</a>
            <span v-show="disclaimer">
                This calculator is intended to be used as a tool to estimate your potential monthly payments based on the figures provided. The results provided by this calculator are intended for illustrative purposes only. This calculator does not represent an offer, solicitation, or extension of credit. Calculation does not include taxes and fees. The actual interest rates, fees, and terms for which you may qualify may vary depending on a variety of factors including your credit score, the amount financed, the type of vehicle, and the lending institution's policies.
            </span>
        </p>
    </div>
</template>
<script>
    import { debounce } from '../common/debounce';
    import decimal from '../common/decimal';

    export default {
        props: ['rate', 'price'],
        data: function () {
            return {
                disclaimer: false,
                downPayment: 2000,
                months: 60,
            };
        },
        computed: {
            downPaymentCurrency() {
                return '$' + (1*this.downPayment).toLocaleString('en-US', { minimumFractionDigits: 0 });
            },
            monthlyPayment() {
                let m = 1 * this.months;
                let P = decimal.subtract(this.price, this.downPayment);
                let r = decimal.divide(this.rate, 12, 10);
                let a = decimal.multiply(r, Math.pow(1 + r, m), 10);
                let b = Math.pow(1 + r, m) - 1;
                let value = decimal.multiply(P, decimal.divide(a, b, 10));
                return '$' + value.toLocaleString('en-US', { minimumFractionDigits: 2 });
            }
        },
        created() {
            if (localStorage.paymentCalculator) {
                const pc = JSON.parse(localStorage.paymentCalculator);
                this.downPayment = Math.min(pc.downPayment, 1 * this.price);
                this.months = pc.months;
            }
        },
        methods: {
            save() {
                const downPayment = this.downPayment;
                const months = this.months;
                debounce('pc', () => {
                    localStorage.paymentCalculator = JSON.stringify({ downPayment, months });
                });
            }
        },
        watch: {
            downPayment() {
                this.save();
            },
            months() {
                this.save();
            }
        }
    }
</script>